"use client";

import { Compass, Box, Leaf, ArrowRight } from "lucide-react";
import { Card } from "@/components/ui/card";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { Link } from "@/components/common/Link";
export default function () {
  const {
    ref: headerRef,
    isVisible: headerVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.15
  });
  const {
    ref: cardsRef,
    isVisible: cardsVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.1
  });
  const pillars = [{
    index: "§ 01.1",
    icon: Compass,
    title: "OTA Revenue",
    italicWord: "Management",
    titleSuffix: "",
    description: "Maximize your visibility and conversion rates on major platforms. We optimize your listings to ensure your property stands out in a crowded digital marketplace."
  }, {
    index: "§ 01.2",
    icon: Box,
    title: "Tech Stack",
    italicWord: "Implementation",
    titleSuffix: "",
    description: "Streamline your operations with the right hospitality technology. We recommend and integrate tools that automate tasks and improve guest experiences."
  }, {
    index: "§ 01.3",
    icon: Leaf,
    title: "Revenue",
    italicWord: "Audits",
    titleSuffix: "",
    description: "Identify hidden opportunities for growth. Our comprehensive audits analyze your current performance and provide actionable strategies to boost your bottom line."
  }];
  return <section data-section-id="2110" id="painpointssolution" className="relative overflow-hidden bg-slate-50 py-28 md:py-36">
      {}
      <div aria-hidden="true" className="pointer-events-none absolute right-[-4%] top-[2%] hidden select-none md:block" style={{
      fontFamily: "var(--font-serif)",
      fontSize: "clamp(320px, 52vw, 760px)",
      lineHeight: 0.8,
      color: "transparent",
      WebkitTextStroke: "1px hsl(222 47% 7% / 0.1)",
      opacity: 0.4,
      fontWeight: 350
    }}>
        01
      </div>
      <div aria-hidden="true" className="pointer-events-none absolute right-[-8%] top-[1%] block select-none md:hidden" style={{
      fontFamily: "var(--font-serif)",
      fontSize: "320px",
      lineHeight: 0.8,
      color: "transparent",
      WebkitTextStroke: "1px hsl(222 47% 7% / 0.1)",
      opacity: 0.4,
      fontWeight: 350
    }}>
        01
      </div>

      <div className="relative mx-auto max-w-[1440px] px-5 md:px-8 lg:px-14">
        {}
        <div ref={headerRef} className={`grid grid-cols-1 gap-8 lg:grid-cols-12 lg:gap-6 transition-all duration-700 ease-out ${headerVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4"}`}>
          <div className="lg:col-span-7">
            {}
            <div className="flex items-center gap-2 uppercase" style={{
            fontFamily: "var(--font-sans)",
            fontSize: "0.6875rem",
            fontWeight: 600,
            letterSpacing: "0.18em",
            lineHeight: 1
          }}>
              <span className="text-amber-800">§ 01</span>
              <span className="text-slate-300">—</span>
              <span className="text-slate-500">CORE SERVICES / REVENUE STRATEGY</span>
            </div>

            {}
            <div className="mt-5 flex items-center gap-3">
              <div className="h-px flex-1 bg-slate-200" />
              <div className="flex items-center gap-1">
                <span className="h-1 w-1 rounded-lg bg-amber-800" />
                <span className="h-1 w-1 rounded-lg bg-amber-800" />
                <span className="h-1 w-1 rounded-lg bg-amber-800" />
              </div>
            </div>

            {}
            <h2 className="mt-8 text-slate-900" style={{
            fontFamily: "var(--font-serif)",
            fontSize: "clamp(2.25rem, 4.8vw, 4.5rem)",
            fontWeight: 700,
            letterSpacing: "-0.02em",
            lineHeight: 1.02
          }}>
              Expert revenue{" "}
              <br className="hidden sm:block" />
              solutions for{" "}
              <em style={{
              fontFamily: "var(--font-serif)",
              fontStyle: "italic",
              fontWeight: 400
            }}>
                growth
              </em>
              .
            </h2>
          </div>

          <div className="lg:col-span-5 lg:flex lg:items-end">
            <p className="font-default max-w-md text-slate-700" style={{
            fontSize: "clamp(1.0625rem, 1.2vw, 1.25rem)",
            fontWeight: 400,
            lineHeight: 1.65
          }}>
              HotelRevBaBa provides data-driven strategies to help hotel owners and managers maximize profitability through precision revenue management and modern tech integration.
            </p>
          </div>
        </div>

        {}
        <div ref={cardsRef} className="mt-20 grid grid-cols-1 gap-6 md:gap-7 lg:grid-cols-12 lg:gap-6">
          {pillars.map((pillar, i) => {
          const Icon = pillar.icon;
          return <div key={i} data-index={i} className={`lg:col-span-4 transition-all ease-out ${cardsVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4"}`} style={{
            transitionDuration: "720ms",
            transitionDelay: `${i * 80}ms`
          }}>
                <Card className="group relative h-full overflow-hidden p-9 transition-transform duration-300 ease-out hover:-translate-y-1 shadow-md" style={{
              backgroundColor: "white",
              color: "hsl(222 47% 7%)",
              borderRadius: "0.5rem",
              border: "1px solid hsl(215 16% 88%)"
            }}>
                  {}
                  <span aria-hidden="true" className="pointer-events-none absolute left-3 top-3 h-3.5 w-3.5 opacity-0 transition-opacity duration-300 group-hover:opacity-100" style={{
                borderTop: "1px solid hsl(43 65% 35%)",
                borderLeft: "1px solid hsl(43 65% 35%)"
              }} />
                  <span aria-hidden="true" className="pointer-events-none absolute right-3 top-3 h-3.5 w-3.5 opacity-0 transition-opacity duration-300 group-hover:opacity-100" style={{
                borderTop: "1px solid hsl(43 65% 35%)",
                borderRight: "1px solid hsl(43 65% 35%)"
              }} />
                  <span aria-hidden="true" className="pointer-events-none absolute bottom-3 left-3 h-3.5 w-3.5 opacity-0 transition-opacity duration-300 group-hover:opacity-100" style={{
                borderBottom: "1px solid hsl(43 65% 35%)",
                borderLeft: "1px solid hsl(43 65% 35%)"
              }} />
                  <span aria-hidden="true" className="pointer-events-none absolute bottom-3 right-3 h-3.5 w-3.5 opacity-0 transition-opacity duration-300 group-hover:opacity-100" style={{
                borderBottom: "1px solid hsl(43 65% 35%)",
                borderRight: "1px solid hsl(43 65% 35%)"
              }} />

                  {}
                  <div className="flex items-center gap-2 uppercase" style={{
                fontFamily: "var(--font-sans)",
                fontSize: "0.6875rem",
                fontWeight: 600,
                letterSpacing: "0.18em",
                lineHeight: 1
              }}>
                    <span className="text-amber-800">{pillar.index}</span>
                    <span className="text-slate-300">—</span>
                    <span className="text-slate-500">SERVICE</span>
                  </div>

                  {}
                  <div className="mt-8 transition-transform duration-[400ms] ease-out group-hover:rotate-6">
                    <Icon size={32} strokeWidth={1.5} className="text-amber-800" />
                  </div>

                  {}
                  <h3 className="mt-7 text-slate-900" style={{
                fontFamily: "var(--font-serif)",
                fontSize: "clamp(1.5rem, 2.2vw, 2.25rem)",
                fontWeight: 600,
                letterSpacing: "-0.012em",
                lineHeight: 1.15
              }}>
                    {pillar.title}{" "}
                    <em style={{
                  fontFamily: "var(--font-serif)",
                  fontStyle: "italic",
                  fontWeight: 400
                }}>
                      {pillar.italicWord}
                    </em>
                  </h3>

                  {}
                  <p className="font-default mt-5 text-slate-600" style={{
                fontSize: "1rem",
                fontWeight: 400,
                letterSpacing: "0.005em",
                lineHeight: 1.65
              }}>
                    {pillar.description}
                  </p>

                  {}
                  <div className="mt-9 flex items-center gap-3">
                    <div className="h-px flex-1 bg-slate-200" />
                    <div className="flex items-center gap-1">
                      <span className="h-1 w-1 rounded-lg bg-amber-800" />
                      <span className="h-1 w-1 rounded-lg bg-amber-800" />
                      <span className="h-1 w-1 rounded-lg bg-amber-800" />
                    </div>
                  </div>

                  {}
                  <div className="mt-6">
                    <Link to="/OurServicesPage" className="group/link relative inline-flex items-center gap-2 font-default font-semibold text-amber-800" style={{
                  fontSize: "0.9375rem"
                }}>
                      <span className="relative">
                        View details
                        <span className="absolute -bottom-0.5 left-0 h-px w-0 transition-all duration-300 ease-out group-hover/link:w-full bg-amber-800" />
                      </span>
                      <ArrowRight size={16} strokeWidth={2} className="transition-transform duration-300 group-hover/link:translate-x-1" />
                    </Link>
                  </div>
                </Card>
              </div>;
        })}
        </div>
      </div>
    </section>;
}